import {JobRunProgress} from "./job-run-progress";
import {Utils} from "../../../shared/utils/utils";

export class JobRunProgressMapper {

  public static map(data: any): JobRunProgress {
    const BackupRunProgress: JobRunProgress = new JobRunProgress();

    BackupRunProgress.id = data.id;
    BackupRunProgress.websiteId = data.domain_id;
    BackupRunProgress.jobId = data.job_id;
    BackupRunProgress.status = data.status; // "active"|"success"|"fail"
    BackupRunProgress.active = data.status === 'active';
    BackupRunProgress.creationDate = data.created_at ? Utils.getDate(data.created_at) : null;
    BackupRunProgress.updatedDate = data.updated_at ? Utils.getDate(data.updated_at) : null;

    BackupRunProgress.progressPercent = Math.round(data.progress);
    BackupRunProgress.complete = ['success', 'fail'].indexOf(data.status) !== -1;
    BackupRunProgress.message = data.message;

    return BackupRunProgress;
  }

}
